"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleorState = void 0;
const lodash_1 = require("lodash");
const types_1 = require("../api/Checkout/types");
const helpers_1 = require("../helpers");
const LocalStorageHandler_1 = require("../helpers/LocalStorageHandler");
const types_2 = require("./types");
class SaleorState extends helpers_1.NamedObservable {
    constructor(localStorageHandler, apolloClientManager) {
        super();
        this.provideCheckout = (onError, forceReload) => __awaiter(this, void 0, void 0, function* () {
            if (this.isCheckoutCreatedOnline() && !forceReload) {
                return;
            }
            if (navigator.onLine) {
                yield this.provideCheckoutOnline(onError);
            }
            else {
                this.provideCheckoutOffline(forceReload);
            }
            return;
        });
        this.providePayment = (forceReload) => __awaiter(this, void 0, void 0, function* () {
            this.providePaymentOffline(forceReload);
            return;
        });
        this.providePaymentGateways = (onError) => __awaiter(this, void 0, void 0, function* () {
            yield this.providePaymentGatewaysOnline(onError);
        });
        this.onCheckoutUpdate = (checkout) => {
            this.checkout = checkout;
            this.summaryPrices = this.calculateSummaryPrices(checkout);
            this.notifyChange(types_2.StateItems.CHECKOUT, this.checkout);
            this.notifyChange(types_2.StateItems.SUMMARY_PRICES, this.summaryPrices);
        };
        this.onPaymentUpdate = (payment) => {
            this.payment = payment;
            this.notifyChange(types_2.StateItems.PAYMENT, this.payment);
        };
        this.onPaymentGatewaysUpdate = (paymentGateways) => {
            this.availablePaymentGateways = paymentGateways;
            this.notifyChange(types_2.StateItems.PAYMENT_GATEWAYS, this.availablePaymentGateways);
        };
        this.isCheckoutCreatedOnline = () => { var _a; return (_a = this.checkout) === null || _a === void 0 ? void 0 : _a.id; };
        this.provideCheckoutOnline = (onError) => __awaiter(this, void 0, void 0, function* () {
            // 1. Try to take checkout from backend database
            const checkout = this.localStorageHandler.getCheckout();
            if (checkout === null || checkout === void 0 ? void 0 : checkout.token) {
                const { data, error } = yield this.apolloClientManager.getCheckout(checkout === null || checkout === void 0 ? void 0 : checkout.token);
                if (error) {
                    onError(error, types_1.DataErrorCheckoutTypes.GET_CHECKOUT);
                }
                else if (data) {
                    this.localStorageHandler.setCheckout(data);
                    return;
                }
            }
            // 2. Try to take checkout from local storage
            const checkoutModel = this.localStorageHandler.getCheckout();
            if (checkoutModel) {
                this.onCheckoutUpdate(checkoutModel);
                return;
            }
        });
        this.provideCheckoutOffline = (forceReload) => {
            // 1. Try to take checkout from runtime memory (if exist in memory - has any checkout data)
            if (this.checkout && !forceReload) {
                return;
            }
            // 2. Try to take checkout from local storage
            const checkoutModel = this.localStorageHandler.getCheckout();
            if (checkoutModel) {
                this.onCheckoutUpdate(checkoutModel);
            }
            else {
                this.localStorageHandler.setCheckout({});
            }
        };
        this.providePaymentOffline = (forceReload) => {
            // 1. Try to take checkout from runtime memory (if exist in memory - has any checkout data)
            if (this.payment && !forceReload) {
                return;
            }
            // 2. Try to take checkout from local storage
            const paymentModel = this.localStorageHandler.getPayment();
            if (paymentModel) {
                this.onPaymentUpdate(paymentModel);
            }
            else {
                this.localStorageHandler.setPayment({});
            }
        };
        this.providePaymentGatewaysOnline = (onError) => __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield this.apolloClientManager.getPaymentGateways();
            if (error) {
                onError(error, types_1.DataErrorCheckoutTypes.GET_PAYMENT_GATEWAYS);
            }
            this.onPaymentGatewaysUpdate(data);
        });
        this.localStorageHandler = localStorageHandler;
        this.apolloClientManager = apolloClientManager;
        localStorageHandler.subscribeToChange(LocalStorageHandler_1.LocalStorageItems.CHECKOUT, this.onCheckoutUpdate);
        localStorageHandler.subscribeToChange(LocalStorageHandler_1.LocalStorageItems.PAYMENT, this.onPaymentUpdate);
    }
    calculateSummaryPrices(checkout) {
        var _a, _b, _c;
        const items = checkout === null || checkout === void 0 ? void 0 : checkout.lines;
        const shippingMethod = checkout === null || checkout === void 0 ? void 0 : checkout.shippingMethod;
        const promoCodeDiscount = (_a = checkout === null || checkout === void 0 ? void 0 : checkout.promoCodeDiscount) === null || _a === void 0 ? void 0 : _a.discount;
        if (items && items.length) {
            const firstItemTotalPrice = items[0].totalPrice;
            if (firstItemTotalPrice) {
                const shippingPrice = Object.assign(Object.assign({}, shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price), { amount: ((_b = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price) === null || _b === void 0 ? void 0 : _b.amount) || 0, currency: ((_c = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price) === null || _c === void 0 ? void 0 : _c.currency) ||
                        firstItemTotalPrice.gross.currency });
                const { itemsNetPrice, itmesGrossPrice } = items.reduce((prevVals, item) => {
                    var _a, _b;
                    prevVals.itemsNetPrice += ((_a = item.totalPrice) === null || _a === void 0 ? void 0 : _a.net.amount) || 0;
                    prevVals.itmesGrossPrice += ((_b = item.totalPrice) === null || _b === void 0 ? void 0 : _b.gross.amount) || 0;
                    return prevVals;
                }, {
                    itemsNetPrice: 0,
                    itmesGrossPrice: 0,
                });
                const subtotalPrice = Object.assign(Object.assign({}, firstItemTotalPrice), { gross: Object.assign(Object.assign({}, firstItemTotalPrice.gross), { amount: lodash_1.round(itmesGrossPrice, 2) }), net: Object.assign(Object.assign({}, firstItemTotalPrice.net), { amount: lodash_1.round(itemsNetPrice, 2) }) });
                const discount = Object.assign(Object.assign({}, promoCodeDiscount), { amount: (promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.amount) || 0, currency: (promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.currency) || firstItemTotalPrice.gross.currency });
                const totalPrice = Object.assign(Object.assign({}, subtotalPrice), { gross: Object.assign(Object.assign({}, subtotalPrice.gross), { amount: lodash_1.round(itmesGrossPrice + shippingPrice.amount - discount.amount, 2) }), net: Object.assign(Object.assign({}, subtotalPrice.net), { amount: lodash_1.round(itemsNetPrice + shippingPrice.amount - discount.amount, 2) }) });
                return {
                    discount,
                    shippingPrice,
                    subtotalPrice,
                    totalPrice,
                };
            }
        }
        return {};
    }
}
exports.SaleorState = SaleorState;
//# sourceMappingURL=index.js.map